(function(){
  if (window.__ancoraRTS) return; window.__ancoraRTS = true;
  var me = document.currentScript;
  var API = 'https://sync.ancoraswimwear.com';
  var shop = (me && me.getAttribute('data-shop')) || (window.Shopify && Shopify.shop) || '';
  if (!shop) return;
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  function url(p){ return ROOT.replace(/\/$/, '') + '/' + p.replace(/^\//,''); }
  function esc(s){ return String(s == null ? '' : s).replace(/[&<>"']/g, function(c){ return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]; }); }
  function pareceSku(q){
    var t = (q || '').trim();
    if (!t || /\s/.test(t) || /^[a-z_]+:/i.test(t)) return false;
    return /^[A-Za-z]{0,4}\d{2,}[A-Za-z0-9-]*$/.test(t);
  }
  function queryBusqueda(q){
    var t = (q || '').trim();
    if (!t) return t;
    if (/^[a-z_]+:/i.test(t)) return t;
    if (pareceSku(t)) return t;
    return 'title:' + t;
  }
  function corregirPaginaBusqueda(){
    if (!/\/search/.test(location.pathname)) return;
    var p = new URLSearchParams(location.search), q = p.get('q');
    if (!q) return;
    var mejor = queryBusqueda(q);
    if (mejor === q && p.get('type') === 'product') return;
    p.set('q', mejor);
    if (!p.get('type')) p.set('type', 'product');
    location.replace(location.pathname + '?' + p.toString());
  }
  corregirPaginaBusqueda();

  fetch(API + '/api/public/realtime-search/config?shop=' + encodeURIComponent(shop))
    .then(function(r){ return r.json(); })
    .then(function(cfg){
      if (!cfg || typeof cfg !== 'object') cfg = {};
      if (!cfg.enabled) cfg = Object.assign({enabled:true,search:true,adapter:'impulse',maxProducts:6,minChars:2,style:{}}, cfg, {enabled:true,search:true});
      if (!cfg.enabled) return;
      if (cfg.search) try { initSearch(cfg); } catch(e){ console.warn('[ancora-rts] search', e); }
      // Filtering now lives in the "Filtros de colección" widget (avoids two scripts filtering).
      void initFilters;
    }).catch(function(){});

  /* ---------------- MÓDULO 1: BUSCADOR ---------------- */
  var INPUT_SELECTORS = {
    impulse: ['.site-header__search-input','input.site-header__search-input','#SearchInput','.search-bar__input','[data-predictive-search] input[type=search]','form[action$="/search"] input[name="q"]'],
    generic: ['predictive-search input[type=search]','form[action$="/search"] input[name="q"]','input[type=search][name="q"]']
  };
  function initSearch(cfg){
    var st = cfg.style || {};
    var css = 'body.acrts-search-open{overflow:hidden}'+
      '.header-sticky-wrapper:has([aria-expanded=true]){z-index:100002!important;position:relative}'+
      '.acrts-backdrop{position:fixed;inset:0;background:rgba(17,17,17,.42);z-index:100000}'+
      '.acrts-panel{position:fixed;z-index:100001;margin-top:0;background:'+(st.bg||'#fff')+';color:'+(st.text||'#111')+';border:1px solid '+(st.border||'#e5e5e5')+';border-radius:'+(st.radius!=null?st.radius:8)+'px;box-shadow:0 8px 24px rgba(0,0,0,.12);max-height:min(70vh,calc(100vh - 96px));overflow:auto;text-align:left;font-size:14px}'+
      '.acrts-item{display:flex;gap:10px;align-items:center;padding:8px 12px;text-decoration:none;color:inherit}'+
      '.acrts-item[aria-selected=true],.acrts-item:hover{background:rgba(0,0,0,.05)}'+
      '.acrts-item img{width:'+(st.image_size||56)+'px;height:'+(st.image_size||56)+'px;object-fit:cover;border-radius:4px;flex-shrink:0}'+
      '.acrts-t{font-weight:600;line-height:1.2}.acrts-s{font-size:12px;opacity:.75;font-weight:400}.acrts-p{font-size:13px;opacity:.8}.acrts-oos{font-size:12px;color:#b91c1c}'+
      '.acrts-msg{padding:12px;opacity:.7}.acrts-h{padding:8px 12px 4px;font-size:11px;text-transform:uppercase;letter-spacing:.05em;opacity:.6}'+
      '.acrts-q{display:block;padding:6px 12px;color:inherit;text-decoration:none}.acrts-all{display:block;padding:10px 12px;border-top:1px solid '+(st.border||'#e5e5e5')+';color:'+(st.accent||'#111')+';font-weight:600;text-decoration:none}'+
      '.acrts-hide-native predictive-search [data-predictive-search],.acrts-hide-native .predictive-search,.acrts-hide-native .predictive__screen,.acrts-hide-native #PredictiveWrapper,.acrts-hide-native .site-header__search-results{display:none!important}';
    var s = document.createElement('style'); s.textContent = css; document.head.appendChild(s);
    var sels = (INPUT_SELECTORS[cfg.adapter] || []).concat(INPUT_SELECTORS.generic);
    var bound = new WeakSet();
    function bindAll(){
      sels.forEach(function(sel){
        document.querySelectorAll(sel).forEach(function(inp){
          if (bound.has(inp) || inp.tagName !== 'INPUT') return; bound.add(inp); bind(inp, cfg);
        });
      });
    }
    bindAll();
    document.addEventListener('shopify:section:load', bindAll);
    new MutationObserver(function(){ clearTimeout(bindAll._t); bindAll._t = setTimeout(bindAll, 300); }).observe(document.body, {childList:true, subtree:true});
    document.addEventListener('submit', function(e){
      var f = e.target;
      if (!f || f.tagName !== 'FORM') return;
      var act = (f.getAttribute('action') || '');
      if (act.indexOf('/search') === -1 && !act.endsWith('search')) return;
      var inp = f.querySelector('input[name="q"]');
      if (!inp) return;
      inp.value = queryBusqueda(inp.value);
      if (!f.querySelector('input[name="type"]')) {
        var hid = document.createElement('input');
        hid.type = 'hidden'; hid.name = 'type'; hid.value = 'product';
        f.appendChild(hid);
      }
    }, true);
  }
  var uid = 0;
  function bind(inp, cfg){
    var form = inp.closest('form'); var host = form || inp.parentNode;
    if (getComputedStyle(host).position === 'static') host.style.position = 'relative';
    host.classList.add('acrts-hide-native');
    var nativePs = inp.closest('predictive-search'); if (nativePs) nativePs.classList.add('acrts-hide-native');
    var id = 'acrts-list-' + (++uid);
    var panel = document.createElement('div'); panel.className = 'acrts-panel'; panel.id = id; panel.setAttribute('role','listbox'); panel.hidden = true;
    var backdrop = document.createElement('div'); backdrop.className = 'acrts-backdrop'; backdrop.hidden = true;
    document.body.appendChild(backdrop); document.body.appendChild(panel);
    inp.setAttribute('role','combobox'); inp.setAttribute('aria-autocomplete','list'); inp.setAttribute('aria-controls', id); inp.setAttribute('aria-expanded','false'); inp.setAttribute('autocomplete','off');
    var timer, ctrl, active = -1, items = [];
    function placePanel(){
      var r = inp.getBoundingClientRect();
      var w = Math.min(window.innerWidth - 16, Math.max(300, r.width));
      var left = Math.max(8, Math.min(r.left, window.innerWidth - w - 8));
      panel.style.top = (r.bottom + 4) + 'px';
      panel.style.left = left + 'px';
      panel.style.width = w + 'px';
    }
    function show(html){
      panel.innerHTML = html; panel.hidden = false; backdrop.hidden = false;
      document.body.classList.add('acrts-search-open');
      placePanel();
      inp.setAttribute('aria-expanded','true');
      items = [].slice.call(panel.querySelectorAll('[role=option]')); active = -1;
    }
    function hide(){
      panel.hidden = true; backdrop.hidden = true;
      document.body.classList.remove('acrts-search-open');
      inp.setAttribute('aria-expanded','false'); inp.removeAttribute('aria-activedescendant'); active = -1;
    }
    backdrop.addEventListener('click', hide);
    window.addEventListener('resize', function(){ if (!panel.hidden) placePanel(); });
    window.addEventListener('scroll', function(){ if (!panel.hidden) placePanel(); }, true);
    function mark(){ items.forEach(function(el,i){ el.setAttribute('aria-selected', i===active ? 'true':'false'); }); if (items[active]) { inp.setAttribute('aria-activedescendant', items[active].id); items[active].scrollIntoView({block:'nearest'}); } }
    function money(v){
      var n = Number(v); if (!isFinite(n)) return esc(v);
      var cents = Math.round(n * 100);
      if (window.Shopify && typeof Shopify.formatMoney === 'function') return Shopify.formatMoney(cents);
      try { var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD'; return new Intl.NumberFormat(document.documentElement.lang || undefined, {style:'currency', currency: cur}).format(n); } catch(e){ return n.toFixed(2); }
    }
    function labels(){
      var en = (document.documentElement.lang || '').toLowerCase().indexOf('en') === 0;
      return en ? {prod:'Products',sug:'Suggestions',cols:'Collections',all:'See all results',wait:'Searching…',none:'No results for',oos:'Sold out'}
                : {prod:'Productos',sug:'Sugerencias',cols:'Colecciones',all:'Ver todos los resultados',wait:'Buscando…',none:'Sin resultados para',oos:'Agotado'};
    }
    function cutLabel(p){
      var m = (p.url || '').match(/\/products\/([^?]+)/); var h = m ? m[1] : '';
      var en = (document.documentElement.lang || '').toLowerCase().indexOf('en') === 0;
      if (/-hw/i.test(h)) return en ? 'High waist' : 'Cintura alta';
      if (/-sc/i.test(h)) return en ? 'Classic cut' : 'Corte clásico';
      return p.type || '';
    }
    function run(q){
      if (ctrl) ctrl.abort(); ctrl = new AbortController();
      var L = labels();
      show('<div class="acrts-msg">'+L.wait+'</div>');
      var u = url('search/suggest.json') + '?q=' + encodeURIComponent(q) + '&resources[type]=product,query,collection&resources[limit]=' + (cfg.maxProducts||6) + '&resources[options][unavailable_products]=last&resources[options][fields]=title,product_type,variants.sku,vendor';
      fetch(u, {signal: ctrl.signal, headers:{Accept:'application/json'}}).then(function(r){ if(!r.ok) throw 0; return r.json(); }).then(function(d){
        var r = (d && d.resources && d.resources.results) || {}; var prods = r.products || [], qs = r.queries || [], cols = r.collections || [];
        if (!prods.length && !qs.length && !cols.length) return show('<div class="acrts-msg">'+L.none+' “'+esc(q)+'”</div>');
        var n = 0, h = '';
        if (qs.length) { h += '<div class="acrts-h">'+L.sug+'</div>'; qs.slice(0,3).forEach(function(x){ h += '<a class="acrts-q" role="option" id="'+id+'-'+(n++)+'" href="'+esc(x.url)+'">'+(x.styled_text||esc(x.text))+'</a>'; }); }
        if (prods.length) { h += '<div class="acrts-h">'+L.prod+'</div>'; prods.forEach(function(p){
          var sub = cutLabel(p);
          h += '<a class="acrts-item" role="option" id="'+id+'-'+(n++)+'" href="'+esc(p.url)+'">'+(p.image?'<img src="'+esc(p.image)+'" alt="" loading="lazy">':'')+'<span><span class="acrts-t">'+esc(p.title)+'</span>'+(sub?'<br><span class="acrts-s">'+esc(sub)+'</span>':'')+'<br><span class="acrts-p">'+money(p.price)+'</span>'+(p.available===false?' <span class="acrts-oos">'+L.oos+'</span>':'')+'</span></a>'; }); }
        if (cols.length) { h += '<div class="acrts-h">'+L.cols+'</div>'; cols.slice(0,3).forEach(function(c){ h += '<a class="acrts-q" role="option" id="'+id+'-'+(n++)+'" href="'+esc(c.url)+'">'+esc(c.title)+'</a>'; }); }
        var sq = queryBusqueda(q);
        h += '<a class="acrts-all" role="option" id="'+id+'-'+(n++)+'" href="'+url('search')+'?q='+encodeURIComponent(sq)+'&type=product">'+L.all+'</a>';
        show(h);
      }).catch(function(e){ if (e && e.name === 'AbortError') return; show('<div class="acrts-msg">No se pudo buscar. Pulsa Enter para buscar.</div>'); });
    }
    inp.addEventListener('input', function(e){
      e.stopImmediatePropagation();
      var q = inp.value.trim(); clearTimeout(timer);
      if (q.length < (cfg.minChars||2)) { if (ctrl) ctrl.abort(); return hide(); }
      timer = setTimeout(function(){ run(q); }, 250);
    }, true);
    inp.addEventListener('keydown', function(e){
      if (panel.hidden) return;
      if (e.key === 'ArrowDown') { e.preventDefault(); active = Math.min(items.length-1, active+1); mark(); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); active = Math.max(-1, active-1); mark(); }
      else if (e.key === 'Enter' && items[active]) { e.preventDefault(); window.location.href = items[active].href; }
      else if (e.key === 'Escape') { hide(); }
    });
    document.addEventListener('click', function(e){
      if (panel.hidden) return;
      if (!host.contains(e.target) && !panel.contains(e.target)) hide();
    });
  }

  /* ---------------- MÓDULO 2: FILTROS AJAX ---------------- */
  function initFilters(cfg){
    if (!/\/collections\/[^/]+/.test(location.pathname) && !/\/search/.test(location.pathname)) return;
    var FORM_SEL = 'form#FilterForm, form[id^=CollectionFilterForm], form.filter-form, form[data-collection-filters], form#CollectionSidebarFilterForm, form#FacetFiltersForm, form[id^=FacetFiltersForm]';
    var PARTS = ['[data-section-type="collection-grid"]','#CollectionAjaxContent','.collection-grid__wrapper','#ProductGridContainer','#product-grid','.product-grid','[data-collection-count]','.collection-filter__item--count','.active-filters','.tag-list--active-tags','.pagination','.collection-filter','#CollectionSidebar'];
    var getForm = function(){ return document.querySelector(FORM_SEL); };
    if (!getForm()) return;
    // Impulse ya hace AJAX nativo en sus filtros: si detectamos su controlador, no duplicamos.
    if (cfg.adapter === 'impulse' && (document.querySelector('[data-ajax-enabled="true"]') || (window.theme && theme.settings && theme.settings.ajaxFilters))) { return; }
    function section(){
      var el = getForm().closest('[id^="shopify-section-"]') || document.querySelector('[id^="shopify-section-"][id*="collection"], [id^="shopify-section-"][id*="main"]');
      return el ? el.id.replace('shopify-section-','') : null;
    }
    var busy = null;
    function load(qs, push){
      var sid = section(); var target = location.pathname + (qs ? '?' + qs : '');
      if (!sid) { location.href = target; return; }
      if (busy) busy.abort(); busy = new AbortController();
      document.documentElement.style.cursor = 'progress';
      fetch(location.pathname + '?' + (qs ? qs + '&' : '') + 'section_id=' + encodeURIComponent(sid), {signal: busy.signal})
        .then(function(r){ if (!r.ok) throw 0; return r.text(); })
        .then(function(html){
          var doc = new DOMParser().parseFromString(html, 'text/html'); var changed = 0;
          PARTS.forEach(function(sel){
            var cur = document.querySelectorAll(sel), nw = doc.querySelectorAll(sel);
            if (cur.length && cur.length === nw.length) cur.forEach(function(el,i){ if (el.closest(sel+' '+sel)) return; el.replaceWith(document.importNode(nw[i], true)); changed++; });
          });
          if (!changed) { var root = document.getElementById('shopify-section-' + sid), nroot = doc.body.firstElementChild; if (root && nroot) { root.innerHTML = nroot.innerHTML; changed++; } }
          if (!changed) throw 0;
          if (push) history.pushState({acrts:1}, '', target);
          document.dispatchEvent(new CustomEvent('shopify:section:load', {detail:{sectionId:sid}}));
          document.dispatchEvent(new CustomEvent('ancora:filters:updated'));
        })
        .catch(function(e){ if (e && e.name === 'AbortError') return; location.href = target; })
        .finally(function(){ document.documentElement.style.cursor = ''; });
    }
    function qsFrom(form){
      var fd = new FormData(form), p = new URLSearchParams();
      fd.forEach(function(v,k){ if (v !== '' && k !== 'section_id') p.append(k, v); });
      var cur = new URLSearchParams(location.search); if (cur.get('sort_by') && !p.get('sort_by')) p.set('sort_by', cur.get('sort_by'));
      return p.toString();
    }
    var t;
    document.addEventListener('change', function(e){
      var f = e.target.closest && e.target.closest(FORM_SEL);
      if (f) { e.stopImmediatePropagation(); clearTimeout(t); t = setTimeout(function(){ load(qsFrom(f), true); }, e.target.type === 'number' || e.target.type === 'range' ? 500 : 0); return; }
      if (e.target.name === 'sort_by' || e.target.id === 'SortBy') { e.stopImmediatePropagation(); var p = new URLSearchParams(location.search); p.set('sort_by', e.target.value); p.delete('page'); load(p.toString(), true); }
    }, true);
    document.addEventListener('submit', function(e){ var f = e.target.closest && e.target.closest(FORM_SEL); if (f) { e.preventDefault(); load(qsFrom(f), true); } }, true);
    document.addEventListener('click', function(e){
      var a = e.target.closest && e.target.closest('a[href]'); if (!a || e.metaKey || e.ctrlKey) return;
      var inScope = a.closest('.active-filters, .tag-list--active-tags, .pagination, .collection-filter, '+FORM_SEL);
      if (!inScope) return;
      var u = new URL(a.href, location.href); if (u.pathname !== location.pathname) return;
      e.preventDefault(); load(u.searchParams.toString(), true);
    }, true);
    window.addEventListener('popstate', function(){ load(location.search.replace(/^\?/,''), false); });
  }
})();